import React, { useCallback, useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { TbArrowsExchange2 } from 'react-icons/tb';

import { ReactComponent as Close } from 'assets/images/close.svg';
import styleGuide from 'constants/styleGuide';
import { STORE_ADDR_TYPE } from 'constants/CONSTATNS';
import useAlertConfirmStore from 'zustands/useAlertConfirmStore';

declare global {
  interface Window {
    kakao: any;
  }
}
const Container = styled.div`
  z-index: 1;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  flex-direction: column;
`;
const Wrap = styled.div`
  z-index: 1;
  display: flex;
  position: fixed;
  top: 15%;
  left: 30%;
  right: 30%;
  bottom: 15%;
  padding: 32px;
  min-width: 500px;
  border-radius: 16px;
  flex-direction: column;
  background-color: #fff;
`;
const Background = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
`;
const TitleArea = styled.div``;
const TitleText = styled.strong`
  font-size: 1.7rem;
`;
const CloseBtn = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
`;
const SearchArea = styled.div`
  display: flex;
  position: relative;
  margin-top: 10px;
`;
const SearchInput = styled.input`
  padding: 5px 10px;
  font-size: 1.1rem;
  border-radius: 4px;
  border: 1px solid #e9e9e9;
`;
const SearchBtn = styled.button`
  display: flex;
  margin-left: 5px;
  padding: 0 10px;
  align-items: center;
  border-radius: 8px;
  background-color: #e5f4f2;
`;
const SearchBtnText = styled.span`
  color: #49ae9e;
  font-size: 1.2rem;
`;
const SearchCancelBtn = styled(SearchBtn)`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #eee;
`;
const SearchCancelBtnText = styled(SearchBtnText)`
  color: #999;
`;
const MapWrap = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  margin-top: 10px;
  flex-direction: column;
`;
const SearchResultList = styled.div`
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 1px solid #e9e9e9;
  border-radius: 4px;
  overflow-y: auto;
  background-color: #fff;
`;
const SearchResultItem = styled.button`
  display: flex;
  flex-direction: column;
  padding: 15px 10px;
  width: 100%;

  &:not(:last-child) {
    border-bottom: 1px solid #ddd;
  }

  &:hover {
    background-color: #fafafa;
  }
`;
const SearchResultItemName = styled.strong`
  font-size: 1.2rem;
  margin-bottom: 5px;
`;
const SearchResultItemAddr = styled.span`
  color: #999;
  font-size: 1rem;
`;
const SearchResultItemRoadAddr = styled.span`
  color: #999;
  font-size: 1rem;
`;
const Map = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
`;
const ZoomControler = styled.div`
  z-index: 1;
  position: absolute;
  top: 20px;
  right: 20px;
  width: 36px;
  height: 80px;
  border: 1px solid #bfbfbf;
  overflow: hidden;
  background-color: #f5f5f5;
`;
const ZoonBtn = styled.span`
  display: flex;
  width: 36px;
  height: 40px;
  text-align: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
const ZoonInBtn = styled(ZoonBtn)`
  border-bottom: 1px solid #bfbfbf;
`;
const ZoonBtnImg = styled.img`
  width: 15px;
  height: 15px;
  border: none;
`;
const InfoArea = styled.div``;
const AddrView = styled.div`
  margin-top: 20px;
`;
const AddrText = styled.strong``;
const ToggleArea = styled.div`
  margin-top: 6px;
`;
const ToggleBtn = styled.button`
  display: flex;
  padding: 3px 10px;
  align-items: center;
  border-radius: 20px;
`;
const ToggleBtnText = styled.span`
  margin-left: 3px;
  font-size: 1.1rem;
`;
const SelectArea = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const SelectBtn = styled.button`
  padding: 6px 20px;
  border-radius: 4px;
  background-color: ${styleGuide.palette.primary2};
  &:hover {
    background-color: ${styleGuide.palette.primary2Hover};
  }
`;
const SelectBtnText = styled.strong`
  color: white;
`;

interface IProps {
  storeLat: number;
  storeLong: number;
  storeAddrType: STORE_ADDR_TYPE;
  onClose: () => void;
  onSubmit: (lat: number, long: number, addr: string, addrType: STORE_ADDR_TYPE) => void;
}

export interface IInfoByKeyword {
  address_name: string;
  category_group_code: string;
  category_group_name: string;
  category_name: string;
  distance: string;
  id: string;
  phone: string;
  place_name: string;
  place_url: string;
  road_address_name: string;
  x: string;
  y: string;
}

let map: any = null;
let ps: any = null;
const SearchAddrMap = ({ storeLat, storeLong, storeAddrType, onClose, onSubmit }: IProps) => {
  const { setModalState } = useAlertConfirmStore();

  const [searchValue, setSearchValue] = useState<string>('');
  const [searchResults, setSearchResults] = useState<IInfoByKeyword[]>([]);
  const [lat, setLat] = useState<number>(storeLat);
  const [long, setLong] = useState<number>(storeLong);
  const [addr, setAddr] = useState<string>('');
  const [roadAddr, setRoadAddr] = useState<string>('');
  const [addrType, setAddrType] = useState<STORE_ADDR_TYPE>(storeAddrType);

  const toggleAddrType = useCallback(() => {
    setAddrType(addrType === 'basic' ? 'road' : 'basic');
  }, [addrType]);

  const clickSubmitBtn = () => {
    onSubmit(lat, long, addrType === 'basic' ? addr : roadAddr, addrType);
  };

  // 검색 인풋 상태 핸들링
  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  // 검색 중 엔터키 입력
  const handleKeyupEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') searchPlaces();
  };

  // 키워드 검색 요청
  const searchPlaces = () => {
    if (searchValue === '') {
      return setModalState({ isModalShow: true, title: '키워드 검색', desc: '키워드를 입력해 주세요' });
    }

    ps.keywordSearch(searchValue, placesSearchCB);
  };

  // 장소검색 완료 시 콜백
  const placesSearchCB = (data: IInfoByKeyword[], status: string, pagination: any) => {
    if (status === window.kakao.maps.services.Status.OK) {
      setSearchResults(data);
    } else if (status === window.kakao.maps.services.Status.ZERO_RESULT) {
      return setModalState({ isModalShow: true, title: '키워드 검색', desc: '검색 결과가 존재하지 않습니다' });
    } else if (status === window.kakao.maps.services.Status.ERROR) {
      return setModalState({ isModalShow: true, title: '키워드 검색', desc: '검색 결과 중 오류가 발생했습니다' });
    }
  };

  // 키워드 장소 데이터 초기화
  const cancelKeywordSearch = () => {
    setSearchResults([]);
  };

  // 키워드 장소 선택
  const selectKeyword = (item: IInfoByKeyword) => {
    setLat(Number(item.y));
    setLong(Number(item.x));
    setAddr(item.address_name);
    setRoadAddr(item.road_address_name);
    if (!item.road_address_name) {
      setAddrType('basic');
    }
    map.setCenter(new window.kakao.maps.LatLng(item.y, item.x));
    cancelKeywordSearch();
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://dapi.kakao.com/v2/maps/sdk.js?appkey=${process.env.REACT_APP_KAKAO_KEY}&libraries=services`;
    document.head.appendChild(script);
    var sendAddrInfo = (_lat?: number, _long?: number) => {};
    script.onload = () => {
      window.kakao.maps.load(() => {
        let geocoder = new window.kakao.maps.services.Geocoder();
        let mapContainer = document.getElementById('map');
        let mapOption = {
          center: new window.kakao.maps.LatLng(37.567013415890514, 126.97867484299577),
          level: 7,
        };

        map = new window.kakao.maps.Map(mapContainer, mapOption); // 지도 생성
        ps = new window.kakao.maps.services.Places(); // 장소 검색 객체 생성
        map.setLevel(4, { animate: true });
        // 지도를 클릭한 위치에 표출할 마커입니다
        var marker = new window.kakao.maps.Marker({
          // 지도 중심좌표에 마커를 생성합니다
          position: map.getCenter(),
          text: 'dfasf',
        });
        // 지도에 마커를 표시합니다
        marker.setMap(map);
        // 이동, 확대, 축로 인해 중심좌표가 변경되면 마지막 파라미터로 넘어온 함수를 호출도록 이벤트를 등록합니다.
        window.kakao.maps.event.addListener(map, 'center_changed', function () {
          var latlng = map.getCenter();
          marker.setPosition(latlng);
        });

        // 이동된 마커 위치의 주소,좌표 업데이트
        sendAddrInfo = (_lat?: number, _long?: number) => {
          var latlng = map.getCenter();
          var LAT = latlng.getLat();
          var LONG = latlng.getLng();
          var coord = new window.kakao.maps.LatLng(_lat ? _lat : LAT, _long ? _long : LONG);
          geocoder.coord2Address(coord.getLng(), coord.getLat(), (result: any, status: any) => {
            var addr = result[0].address.address_name;
            var roadAddr = result[0].road_address?.address_name;
            setLat(LAT);
            setLong(LONG);
            setAddr(addr);
            setRoadAddr(roadAddr);
            if (roadAddr === undefined) {
              setAddrType('basic');
            }
          });
        };
        // 마커 이동 이벤트
        window.kakao.maps.event.addListener(map, 'dragend', function () {
          sendAddrInfo();
        });

        map.setCenter(
          new window.kakao.maps.LatLng(
            storeLat !== 0 ? storeLat : 37.567013415890514,
            storeLong !== 0 ? storeLong : 126.97867484299577,
          ),
        );
        sendAddrInfo(storeLat, storeLong);
      });
    };
  }, []);

  const canToggleAddrType = roadAddr !== undefined;

  return (
    <Container>
      <Wrap>
        <TitleArea>
          <TitleText>지도에서 주소 찾기</TitleText>
        </TitleArea>
        <CloseBtn onClick={onClose}>
          <Close fontSize={10} />
        </CloseBtn>
        <SearchArea>
          <SearchInput
            type="text"
            placeholder="키워드로 검색"
            value={searchValue}
            onChange={handleSearchInput}
            onKeyUp={handleKeyupEnter}
            maxLength={20}
          />
          <SearchBtn onClick={searchPlaces}>
            <SearchBtnText>검색</SearchBtnText>
          </SearchBtn>
          {searchResults.length > 0 && (
            <SearchCancelBtn onClick={cancelKeywordSearch}>
              <SearchCancelBtnText>닫기</SearchCancelBtnText>
            </SearchCancelBtn>
          )}
        </SearchArea>
        <MapWrap>
          {searchResults.length > 0 && (
            <SearchResultList>
              {searchResults.map((i) => {
                return (
                  <SearchResultItem key={`${i.place_name}_${i.place_url}`} onClick={() => selectKeyword(i)}>
                    {i.place_name.length > 0 && <SearchResultItemName>{i.place_name}</SearchResultItemName>}
                    <SearchResultItemAddr>지번: {i.address_name}</SearchResultItemAddr>
                    {i.road_address_name.length > 0 && (
                      <SearchResultItemRoadAddr>도로명: {i.road_address_name}</SearchResultItemRoadAddr>
                    )}
                  </SearchResultItem>
                );
              })}
            </SearchResultList>
          )}
          <Map id="map" />
          {/* <!-- 지도 확대, 축소 컨트롤 div 입니다 --> */}
          <ZoomControler>
            <ZoonInBtn
              onClick={() => {
                // 지도 확대, 축소 컨트롤에서 확대 버튼을 누르면 호출되어 지도를 확대하는 함수입니다
                map.setLevel(map.getLevel() - 1);
              }}>
              <ZoonBtnImg src="https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/ico_plus.png" alt="확대" />
            </ZoonInBtn>
            <ZoonBtn
              onClick={() => {
                // 지도 확대, 축소 컨트롤에서 축소 버튼을 누르면 호출되어 지도를 확대하는 함수입니다
                map.setLevel(map.getLevel() + 1);
              }}>
              <ZoonBtnImg src="https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/ico_minus.png" alt="축소" />
            </ZoonBtn>
          </ZoomControler>
        </MapWrap>
        <InfoArea>
          <AddrView>
            {(addr.length > 0 || roadAddr?.length > 0) && <AddrText>{addrType === 'basic' ? addr : roadAddr}</AddrText>}
          </AddrView>
          <ToggleArea>
            <ToggleBtn
              onClick={toggleAddrType}
              disabled={!canToggleAddrType}
              style={{ backgroundColor: canToggleAddrType ? '#f7f7f7' : '#ddd' }}>
              <TbArrowsExchange2 size={16} color="#505054" />
              <ToggleBtnText>
                {addrType === 'basic' ? (canToggleAddrType ? '도로명으로 보기' : '도로명 없음') : '지번으로보기'}
              </ToggleBtnText>
            </ToggleBtn>
          </ToggleArea>
          <SelectArea>
            <SelectBtn onClick={clickSubmitBtn}>
              <SelectBtnText>현재 위치로 주소 설정하기</SelectBtnText>
            </SelectBtn>
          </SelectArea>
        </InfoArea>
      </Wrap>
      <Background onClick={onClose} />
    </Container>
  );
};
export default SearchAddrMap;
